import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import LogoCloud from "@/sections/LogoCloud";
import HowItWorks from "@/sections/HowItWorks";
import Features from "@/sections/Features";
import Metrics from "@/sections/Metrics";
import Pricing from "@/sections/Pricing";
import Testimonials from "@/sections/Testimonials";
import FAQ from "@/sections/FAQ";
import Waitlist from "@/sections/Waitlist";
import Footer from "@/sections/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#09090B] text-[#FAFAFA] overflow-x-hidden">
      <Navbar />
      <Hero />
      <LogoCloud />
      <HowItWorks />
      <Features />
      <Metrics />
      <Pricing />
      <Testimonials />
      <FAQ />
      <Waitlist />
      <Footer />
    </main>
  );
}
